var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-container"},[_c('p',[_vm._v("Copyright © "+_vm._s(_vm.year)+" Blinds & Drapes ® All Rights Reserved.")]),_c('p',[_vm._v("Version 1.0.0")])])}
var staticRenderFns = []

export { render, staticRenderFns }